import React from "react";
import { useLocation, useHistory } from "react-router-dom";
import { IOffer } from "./Types";

function Banner(props: { offer: IOffer }) {
    const history = useHistory();
    const location = useLocation();
    const pageURL = window.location.origin;
    const routeToOfferPage = () => {
        let offerPagePath = "/sales_landing/step2" + location.search;
        history.push(offerPagePath, { from: 'saleslanding page' } );
        window.addToDataLayer({ event: "dtcSalesLandingBtnGetProtected" });
        window.addToDataLayer({
            event: "VPV",
            pageName: pageURL + "/app/sales_landing/step2" + location.search,
        });
    };

    return (
        <>
            <div className="container-fluid slider">
                <div className="row">
                    <div className="sales-landing-banner-overlay">
                        <div></div>
                    </div>
                    <div className="col-10 offset-1 col-sm-10 offset-sm-1 col-md-8 offset-md-2 banner">
                        <h1>Identity Thieves Don't Rest.</h1>
                        <p>Luckily, neither does IdentityForce. We monitor your personal information 24/7, quickly alert you to threats, and help protect you.</p>
                        <p>Sign Up For ANY Annual Plan, Get Your Savings Today</p>
                        <p id="p-button-container">
                            <button className="btn-default btn-primary btn-md btn-sm protected-button" onClick={routeToOfferPage} type="button">
                                <span>GET PROTECTED</span>
                            </button>
                        </p>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Banner;
